import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Translation } from 'react-i18next';

import {
  fetchMe,
  generateUserQrCode,
  clearGenerateUserQrCode,
} from 'redux/users/actions';
import {
  patchUser,
} from 'redux/settings/actions';

import { Checkbox } from 'semantic-ui-react';
import Button from 'components/elements/buttons/Button';

import fileDownload from 'js-file-download';

import './AvatarQrCodeGenerator.css';

export const downloadQrCode = code => {
  const qrCodeUrl = code;
  let downloadedFile;
  fetch(qrCodeUrl)
    .then(res => res.blob())
    .then(blob => (downloadedFile = blob))
    .then(() => { fileDownload(downloadedFile, 'qrcode-heylinkme-profile.png'); })
};

class AvatarQrCodeGenerator extends Component {
  static propTypes = {
    me: PropTypes.object,
    userQrCodeGeneratedSuccess: PropTypes.object,
    fetchMe: PropTypes.func,
    generateUserQrCode: PropTypes.func,
    clearGenerateUserQrCode: PropTypes.func,
    patchUser: PropTypes.func,
  };
  static defaultProps = {
    me: null,
    userQrCodeGeneratedSuccess: null,
    fetchMe: null,
    generateUserQrCode: null,
    clearGenerateUserQrCode: null,
    patchUser: null,
  };
  state = {
    showLoader: false,
  };

  componentDidUpdate(prevProps) {
    if (prevProps.me.qr_code_image !== this.props.me.qr_code_image) {
      setTimeout(() => {
        this.setState({ showLoader: false });
        this.props.clearGenerateUserQrCode();
      }, 500);
    }

    if (this.props.userQrCodeGeneratedSuccess && prevProps.userQrCodeGeneratedSuccess !== this.props.userQrCodeGeneratedSuccess) {
      this.props.fetchMe();
    }
  }

  componentWillUnmount() {
    this.props.clearGenerateUserQrCode();
  }

  handleGenerateQrCode = () => {
    this.setState({ showLoader: true });
    this.props.generateUserQrCode();
  }

  handleDownloadQrCode = () => {
    downloadQrCode(this.props.me.qr_code_image);
  };

  onCheckboxChange = data => {
    const form = new FormData();
    form.append(data.name, data.checked);
    this.props.patchUser(form);
  };

  renderQrCodeControlls = () => {
    const { me } = this.props;
    const { qr_code_image = '', qr_code_is_hidden = true, avatar_is_hidden = false } = me;

    return (
      <Translation>
        {(t) => (
          <div className="avatar-qr-code-generator-controls">
            <div className="avatar-qr-code-generator-controls-wrapper">
              {qr_code_image && Boolean(qr_code_image) ?
                <>
                  {!avatar_is_hidden &&
                    <div className="switcher-wrapper-container">
                      <span><strong>{t("Hide QR Code")}</strong></span>
                      <div className="switcher-wrapper">
                        <span>{t("OFF")}</span>
                        <Checkbox
                          toggle
                          checked={qr_code_is_hidden}
                          name="qr_code_is_hidden"
                          onChange={(_e, data) => { this.onCheckboxChange(data); }}
                        />
                        <span>{t("ON")}</span>
                      </div>
                    </div>
                  }
                  <Button
                    className="avatar-qr-code-btn download"
                    onClick={this.handleDownloadQrCode}
                  >
                    <div className="icon" />
                    <div className="text">{t("Download QR Code")}</div>
                  </Button>
                </>
                :
                <Button
                  className="avatar-qr-code-btn generate"
                  onClick={this.handleGenerateQrCode}
                  loading={this.state.showLoader}
                >
                  <div className="icon" />
                  <div className="text">{t("Generate QR Code")}</div>
                </Button>
              }
            </div>
          </div>
        )}
      </Translation>
    );
  };

  render() {
    const { me } = this.props;
    const { qr_code_image = '' } = me;

    if (!me) return null;

    return (
      <Translation>
        {(t) => (
          <div className="avatar-qr-code-generator__component">
            <div className="avatar-qr-code-generator-wrapper">
              {qr_code_image && Boolean(qr_code_image) ?
                <p>{t("Turn on placement of your QR code or download it in the high resolution for the offline/online promo activities, merch, stickers, profiles and content.")}</p>
                :
                <p>{t("Generate your QR code & download it in the high resolution for the offline/online promo activities, merch, stickers, profiles and content.")}</p>
              }
              <p className="avatar-qr-code-unique-text">{t("Your QR code is unique and only belongs to you")}</p>
              {this.renderQrCodeControlls()}
            </div>
          </div>
        )}
      </Translation>
    );
  }
};

const mapStateToProps = state => (
  {
    me: state.usersReducer.me,
    userQrCodeGeneratedSuccess: state.usersReducer.userQrCodeGeneratedSuccess,
    userQrCodeGeneratedError: state.usersReducer.userQrCodeGeneratedError,
  }
);

export default connect(
  mapStateToProps,
  {
    fetchMe,
    patchUser,
    generateUserQrCode,
    clearGenerateUserQrCode,
  },
)(AvatarQrCodeGenerator);
